import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { BASE_URL } from './config'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$http = axios// 绑定到Vue原型上，方便全局调用
Vue.prototype.$BASE_URL = BASE_URL// 绑定到Vue原型上，方便全局调用

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
